import { ReactNode, useEffect, useMemo } from "react";
import { useGetStrategyDashboardHeatsByIdsMutation } from "src/store/api/generatedApi";
import { useTenant } from "hooks/settings";
import { HeatsDataContext } from "./HeatsDataContext";
import { useHeatsDataContextValue } from "./useHeatsDataContextValue";

interface OutlierHeatsDataProviderProps {
  children: ReactNode;
  heatIds: string[];
  page: number;
  rowsPerPage: number;
}

export const OutlierHeatsDataProvider = ({
  children,
  heatIds,
  page,
  rowsPerPage,
}: OutlierHeatsDataProviderProps) => {
  const tenantName = useTenant();

  const currentHeatIds = useMemo(() => {
    const sortedHeatIds = [...heatIds].sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true })
    );
    const start = page * rowsPerPage;
    return sortedHeatIds.slice(start, start + rowsPerPage);
  }, [heatIds, page, rowsPerPage]);

  const [trigger, { data, isLoading: isHeatsLoading, isError: isHeatsError }] =
    useGetStrategyDashboardHeatsByIdsMutation();

  useEffect(() => {
    if (currentHeatIds.length > 0) {
      void trigger({
        tenantName,
        heatIds: currentHeatIds,
      });
    }
  }, [currentHeatIds, tenantName, trigger]);

  const value = useHeatsDataContextValue({
    data,
    isFetching: isHeatsLoading,
    isLoading: isHeatsLoading,
    isError: isHeatsError,
  });

  return <HeatsDataContext value={value}>{children}</HeatsDataContext>;
};
